import React from 'react'

import tw from 'twin.macro'

import {
  useListenItemPreviewImgQuery,
  useListenOneTimeProductQuery,
  useListenProductCurrencyQuery,
} from 'modules/ProductInfo/productInfoApi'

import { CURRENCY_SYMBOL } from 'common/constants/currencyConstants'
import {
  getAppliedPromo,
  getProductCurrency,
  getProductDurationText,
  getPromoPrice,
} from 'modules/ProductInfo/utils/utils'

function Product({ coachOrgId, productId, coupons }) {
  const { data: product } = useListenOneTimeProductQuery({ coachOrgId, productId })
  const { data: currencyData } = useListenProductCurrencyQuery({ coachOrgId })
  const { data: itemImgData } = useListenItemPreviewImgQuery({
    coachOrgId,
    itemId: product?.item?.id,
    itemType: product?.item?.type,
  })
  const isProductLoading = product === undefined || product?.isLoading
  const isItemImgLoading = itemImgData === undefined || itemImgData?.isLoading
  const itemImg = isItemImgLoading ? null : itemImgData
  const productImg = isProductLoading ? null : product?.previewImg
  const image = productImg || itemImg

  const currency = getProductCurrency({ productCurrency: product?.currency, defaultCurrency: currencyData })
  const currencySymbol = CURRENCY_SYMBOL[currency]
  const appliedPromo = getAppliedPromo({ product, coupons })
  const appliedCoupon = coupons?.[appliedPromo?.stripeCouponId]
  const hasActiveCoupon = appliedCoupon && appliedCoupon?.type !== 'trialOnly'

  return (
    <div className='flex flex-col border-2 border-gray-200 rounded-xl overflow-hidden'>
      <div className='flex items-center p-4'>
        <div className='relative flex-none bg-gray-300 rounded-md w-14 h-14 mr-4 overflow-hidden'>
          {Boolean(image) && (
            <img src={image} alt={product?.stripeProductName} className='w-full h-full object-cover object-center' />
          )}
        </div>
        <div>
          <h4>{product?.stripeProductName || 'Untitled Product'}</h4>
          <p className='text-xs text-gray-500 line-clamp-2'>{product?.description}</p>
        </div>
      </div>
      {Boolean(product?.price) && (
        <div css={[tw`p-4 border-t border-b-gray-300`, hasActiveCoupon && tw`pt-6`]}>
          <div className='relative flex-col flex items-start'>
            {hasActiveCoupon && (
              <div css={[tw`absolute flex flex-col items-start left-0 -top-3`]}>
                {hasActiveCoupon && (
                  <span className='font-bold flex text-xs line-through decoration-red-500'>
                    {currencySymbol}
                    {(product?.price / 100).toFixed(2)}&nbsp;{currency}
                  </span>
                )}
              </div>
            )}
            <span className='text-xl font-bold'>
              {currencySymbol}
              {hasActiveCoupon
                ? (getPromoPrice({ coupon: appliedCoupon, price: product?.price }) / 100).toFixed(2)
                : (product?.price / 100).toFixed(2)}
              &nbsp;{currency}
            </span>
            <span className='text-sm'>
              {getProductDurationText({
                accessEnd: product?.accessEnd,
                accessUnit: product?.accessUnit,
                accessValue: product?.accessValue,
              })}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export default Product
